import React, { useEffect, useState } from 'react';
import { DNABox, Icon, Iffy, Tab, TabBar } from '@alucio/lux-ui';
import { Chat } from '@alucio/video';
import { Pressable } from 'react-native';
import colors from '@alucio/lux-ui/lib/theming/themes/alucio/colors';
import { SelectedRightSideBarComponentEnum, useMeetingControls, } from '../../../../../../../src/packages/video/src/hooks/useMeetingControls/useMeetingControl';
const SideBarTabBar = (props) => {
    function selectedOption(index) {
        props.onTabSelected(index);
    }
    const [tabBarKey, setTabBarKey] = useState(0);
    useEffect(() => {
        setTabBarKey(props.tabs.length);
    }, [props.tabs.length]);
    return (React.createElement(TabBar, { selectedIndex: props.tabSelected, style: { height: 56, minWidth: 280 }, onSelect: selectedOption, key: `virtual_tab_bar_${tabBarKey}` }, props.tabs.map((name, id) => (React.createElement(Tab, { title: name, key: `virtual_tab_${id}` })))));
};
const RightSidePanel = (props) => {
    const { isRightSideBarVisible, toggleRightBarHandler, selectedSideBarComponent, selectTabOption, visibleRightBarComponentsHandler, } = useMeetingControls();
    useEffect(() => {
        if (props.children) {
            visibleRightBarComponentsHandler([
                SelectedRightSideBarComponentEnum.CHAT,
                SelectedRightSideBarComponentEnum.NOTES,
            ]);
        }
        else {
            visibleRightBarComponentsHandler([SelectedRightSideBarComponentEnum.CHAT]);
        }
    }, [props.children]);
    if (!isRightSideBarVisible)
        return null;
    const tabs = props.children ? ['Presenter Notes', 'Chat'] : ['Chat'];
    const getSelectedTab = props.children ? selectedSideBarComponent : 0;
    const controlTabs = props.children
        ? (React.createElement(React.Fragment, null,
            React.createElement(Iffy, { is: getSelectedTab === 0 },
                React.createElement(DNABox, { style: { maxWidth: 280 } }, props.children)),
            React.createElement(Iffy, { is: getSelectedTab === 1 },
                React.createElement(Chat, null))))
        : React.createElement(Chat, null);
    return (React.createElement(DNABox, { fill: true, style: { maxWidth: 280, backgroundColor: colors['color-text-basic'] } },
        React.createElement(DNABox, { appearance: "col" },
            React.createElement(DNABox, { alignX: "end", style: { padding: 14 } },
                React.createElement(Pressable, { onPress: () => toggleRightBarHandler() },
                    React.createElement(Icon, { name: "close", style: { width: 24, height: 20 } }))),
            React.createElement(SideBarTabBar, { tabs: tabs, tabSelected: getSelectedTab !== null && getSelectedTab !== void 0 ? getSelectedTab : 0, onTabSelected: (tab) => selectTabOption(tab) }),
            controlTabs)));
};
export default RightSidePanel;
//# sourceMappingURL=RightSideBar.js.map